import { render, staticRenderFns } from "./platform-editor.vue?vue&type=template&id=2aced3bb&scoped=true&"
import script from "./platform-editor.vue?vue&type=script&lang=js&"
export * from "./platform-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aced3bb",
  null
  
)

export default component.exports